import React, { useMemo } from "react";
import "../../tailwind.css";
import { IConfidenceLevelGraph } from "../../types/ConfidenceLevelGraph.types";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

const ConfidenceLevelGraph: React.FC<IConfidenceLevelGraph> = (props) => {
  const data = useMemo(() => props.data, [props.data]);

  if (!data) {
    return null;
  }

  const dataSets = [
    {
      label: data.area1.areaName || "Area 1",
      data: data.area1.data,
      backgroundColor: "#48BB78",
      stack: "Stack1",
      categoryPercentage: 0.5,
      barPercentage: 0.8,
      animation: false,
    },
    {
      label: data.area2.areaName || "Area 2",
      data: data.area2.data,
      backgroundColor: "#ED8936",
      stack: "Stack2",
      categoryPercentage: 0.5,
      barPercentage: 0.8,
      animation: false,
    },
    {
      label: "General",
      data: data.general.data,
      backgroundColor: "#667EEA",
      stack: "Stack3",
      categoryPercentage: 0.5,
      barPercentage: 0.8,
      animation: false,
    },
  ];

  if (data.TLData) {
    dataSets.push({
      label: data.TLData.areaName || "TL",
      data: data.TLData.data,
      backgroundColor: "#F56565",
      stack: "Stack4",
      categoryPercentage: 0.5,
      barPercentage: 0.8,
      animation: false,
    });
  }

  return (
    <div className="mt-[12px] !h-graph w-full !justify-stretch !items-stretch">
      <Bar
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              labels: {
                boxWidth: 8,
                boxHeight: 8,
                borderRadius: 2,
                useBorderRadius: true,
              },
            },
          },
          // barThickness: '20px',
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
              },
            },
            y: {
              display: true,
              position: "right",
              min: 0,
              max: 5,
              ticks: {
                stepSize: 1,
              },
            },
          },
          maintainAspectRatio: false,
        }}
        data={{
          labels: props.labels ?? ["Start", "Shift 7", "Shift 14", "End"],
          datasets: dataSets as any,
          // ...(data.TLData !== undefined && {
          //   label: data.TLData.areaName || "TL",
          //   data: data.TLData.data,
          //   backgroundColor: "#A0AEC0",
          //   stack: "Stack4",
          //   categoryPercentage: 0.5,
          //   barPercentage: 0.8,
          //   animation: false,
          // }))
        }}
      />
    </div>
  );
};

export default React.memo(ConfidenceLevelGraph);
